<div class="tools-container" [formGroup]="toolsFormGroup">
  <h4 class="tools-title">{{ 'PRESENTER.TEXT_TOOLS.TITLE' | translate }}</h4>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEXT_TOOLS.TEXT' | translate }}</mat-label>
    <input matInput [formControl]="textControl" />
  </mat-form-field>

  <gb-presenter-tools-text [toolsFormGroup]="toolsFormGroup"></gb-presenter-tools-text>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEXT_TOOLS.DECORATION' | translate }}</mat-label>
    <mat-select [formControl]="textDecorationControl">
      @for (decoration of textDecorationOptions; track decoration.value) {
        <mat-option [value]="decoration.value">{{ decoration.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEXT_TOOLS.LINE_HEIGHT' | translate }}</mat-label>
    <input matInput type="number" [formControl]="lineHeightControl" step="0.1" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.TEXT_TOOLS.LETTER_SPACING' | translate }}</mat-label>
    <input matInput type="number" [formControl]="letterSpacingControl" min="0" max="20" />
    <span matTextSuffix>{{ 'PX' | translate }}</span>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_WIDTH' | translate }}</mat-label>
    <input matInput type="number" [formControl]="borderWidthControl" min="0" max="100" />
    <span matTextSuffix>{{ 'PX' | translate }}</span>
  </mat-form-field>

  <gb-token-color-picker
    circleDiameter="38px"
    [control]="borderColorControl"
    labelTranslateKey="PRESENTER.COMMON_TOOL_OPTIONS.BORDER_COLOR"
    cpPosition="right"
    [showDropdown]="true"
  ></gb-token-color-picker>

  <mat-form-field>
    <mat-label>{{ 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE' | translate }}</mat-label>
    <mat-select [formControl]="borderStyleControl">
      @for (option of borderStyleOptions; track option.value) {
        <mat-option [value]="option.value">{{ option.label | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
